/** @format */

import {Box, IconButton} from '@mui/material';
import {styled} from '@mui/material/styles';

export const ChatAreaRoot = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  height: '100%',
  overflow: 'hidden',
}));

export const MessagesContainer = styled(Box)(({theme}) => ({
  flex: 1,
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  padding: theme.spacing(4),
}));

export const PlaceholderContainer = styled(Box)(() => ({
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const InputContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'flex-end',
  gap: theme.spacing(2),
  padding: theme.spacing(3, 4),
  borderTop: `1px solid ${theme.palette.semantic_dark?.surface.surface2}`,
}));

export const ThinkingContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  alignSelf: 'flex-start',
  padding: theme.spacing(2, 4),
  color: theme.palette.semantic_dark?.surface.onSurfaceMuted,
}));

export const SendButton = styled(IconButton)(({theme}) => ({
  color: theme.palette.semantic_dark?.primary.main,

  '&.Mui-disabled': {
    color: theme.palette.semantic_dark?.disabled.inverseDisabled,
  },
}));
